/**
 * Main app functions
 *
 * @package    Direct Wire and Cable
 * @copyright  Copyright (c) 2016 Synapse Marketing Solutions (http://www.synapseresults.com)
 * @version    1.0.0
 * @since      1.0.0
 */

if ( typeof ( $ ) === "undefined" ) {
	var $ = jQuery;
}

/*************************************************************************************
 * Global Vars
 *************************************************************************************/
var win = $( window ),
    doc = $( document );

var aboveHeader = document.querySelector( "#nav-placeholder" );
var primaryHead = document.querySelector( "#masthead" );
var aboveHead = document.querySelector( ".secondary-nav" );
var logo = document.querySelector( ".logo.primary" );
var logoFixed = document.querySelector( ".logo.fixed" );

/*************************************************************************************
 * Call functions on Doc Ready
 *************************************************************************************/
doc.ready( function() {
	
	// Preloader
	function hidePreloader() {
		var preloader = $( ".spinner-wrapper" );
		preloader.fadeOut( 550 );
	}
	hidePreloader();
	
	// Fixes the sticky header on page load
	var bounding = aboveHeader.getBoundingClientRect();
	if ( bounding.top >= 0 && bounding.left >= 0 && bounding.right <=
	     ( window.innerWidth || document.documentElement.clientWidth ) &&
	     bounding.bottom <=
	     ( window.innerHeight || document.documentElement.clientHeight ) ) {
	} else {
		primaryHead.classList.add( "sticky" );
		aboveHead.classList.add( "animate__animated", "animate__fadeOut" );
		aboveHead.classList.remove( "animate__fadeIn" );
		logoFixed.classList.add( "animate__animated", "animate__fadeIn" );
		logoFixed.classList.remove( "animate__fadeOut" );
		logo.classList.add( "animate__animated", "animate__fadeOut" );
		logo.classList.remove( "animate__fadeIn" );
		$( ".logo.fixed" ).css( { "height": "auto" } );
	}
	
	// Adds a class to the core main nav ul's for the mega nav
	var megaNavClass = document.querySelectorAll(
			"#menu-main-nav > li.menu__item--has-children > .mega-menu-container > ul > li" );
	for ( var i = 0; i < megaNavClass.length; i++ ) {
		if ( megaNavClass[ i ].classList.contains( "menu__item--has-children" ) ) {
			megaNavClass[ i ].parentNode.classList.add( "-has-children" );
		}
	}
	
	// Home slider
	var home_slider = $( ".home-slant-slide" )
	home_slider.on('init', function(){
		var puppeteer = slider_puppeteer.create();
		puppeteer.init();
	});
	home_slider.slick( {
	    dots:      false,
	    autoplay:  false,
	    infinite:  true,
	    prevArrow: "<button type=\"button\" class=\"slick-prev icon-previous\"><span class=\"sr-only\">Previous</span></button>",
	    nextArrow: "<button type=\"button\" class=\"slick-next icon-next\"><span class=\"sr-only\">Next</span></button>",
	    // fade: true,
	} );

	// Tesimonial slider
	$( ".testimonial-slide" ).slick( {
		dots:      false,
		autoplay: true,
		autoplaySpeed: 6000,
		infinite:  true,
		prevArrow: "<button type=\"button\" class=\"slick-prev icon-previous\"><span class=\"sr-only\">Previous</span></button>",
		nextArrow: "<button type=\"button\" class=\"slick-next icon-next\"><span class=\"sr-only\">Next</span></button>",
	} );
	
	// Page Banner Slider
	$( ".page-top-banner-container:not(.no-slick)" ).slick( {
	    dots:           false,
	    autoplay:       false,
	    infinite:       true,
	    prevArrow:      "<button type=\"button\" class=\"slick-prev icon-previous\"><span class=\"sr-only\">Previous</span></button>",
	    nextArrow:      "<button type=\"button\" class=\"slick-next icon-next\"><span class=\"sr-only\">Next</span></button>",
	    adaptiveHeight: true,
	    // fade: true,
	} );

	// Featured Products Slider
	$( ".featured-products .products.slider" ).slick( {
	    mobileFirst:    false,
	    autoplay:       false,
	    infinite:       true,
	    dots:           false,
	    slidesToShow:   4,
	    slidesToScroll: 4,
	    adaptiveHeight: true,
	    prevArrow:      "<button type=\"button\" class=\"slick-prev icon-previous\"><span class=\"sr-only\">Previous</span></button>",
		nextArrow:      "<button type=\"button\" class=\"slick-next icon-next\"><span class=\"sr-only\">Next</span></button>",
		responsive: [
			{
				breakpoint: 1300,
				settings: {
					slidesToShow:   2,
	    			slidesToScroll: 2,
				}
			}, {
				breakpoint: 768,
				settings: {
					slidesToShow:   1,
	    			slidesToScroll: 1,
				}
			},
		]
	} );
	
	// Trigger request info modal on page load with url
	var requestInfo = window.location.href.split( "#" );
	if ( requestInfo[ 1 ] == "request-info" ) {
		$( "body" ).toggleClass( "request-flyout" );
		$( ".request-flyout.-info" ).toggleClass( "open" );
	}
	
	// Mobile Menu
	document.querySelector( ".mobile-icon-container label[for=menuIcon]" )
	        .addEventListener( "click", () => {
		        api.open();
	        } );
	
	// Request Information flyout Mobile functionality
	var infoPreviousScroll = 0;
	if ( $( window ).innerWidth() < 700 ) {
		$( window ).scroll( function() {
			var infoCurrentScroll = $( this ).scrollTop();
			if ( infoCurrentScroll < 100 ) {
				$( ".request-flyout.-info" ).removeClass( "scrolling-up" );
				$( ".request-flyout.-info" ).addClass( "mobile-version" );
			} else if ( infoCurrentScroll > 0 && infoCurrentScroll <
			            $( document ).height() - $( window ).height() ) {
				if ( infoCurrentScroll > infoPreviousScroll ) {
					// User scrolling down
					$( ".request-flyout.-info" ).removeClass( "scrolling-up" );
					$( ".request-flyout.-info" ).addClass( "mobile-version" );
				} else if(infoCurrentScroll == infoPreviousScroll) {
					// User stopped scrolling
					// Do nada here
				} else {
					// User scrolling up
					$( ".request-flyout.-info" ).addClass( "scrolling-up" );
				}
				infoPreviousScroll = infoCurrentScroll;
			}
		} );
		
		$( ".request-flyout.-info" ).css( { "height": "auto" } );
		$( ".request-flyout.-quote" ).css( { "height": "auto" } );
		$( ".request-flyout.-info" ).addClass( "mobile-version" );
		$( ".request-flyout.-quote" ).addClass( "mobile-version" );
	} else {
		$( ".request-flyout.-info" )
				.removeClass( "scrolling-up" )
				.removeClass( "mobile-version" );
		$( ".request-flyout.-quote" ).removeClass( "mobile-version" );
	}
	
} ); //Doc Ready

window.addEventListener("load", function(){
	// Featured Products Slider
	// Must be loaded after slick.. if its enabled
	var featuredSlide = document.querySelectorAll('.products.slider .product');
	var finalHeight = 0;
	if(featuredSlide.length > 0) {
		for(var slide = 0; slide < featuredSlide.length; slide++) {
			var x = featuredSlide[slide].getBoundingClientRect();
			if(x.height > finalHeight) {
				finalHeight = Math.round(x.height);
			}
		}
		for(var slide2 = 0; slide2 < featuredSlide.length; slide2++) {
			document.querySelectorAll('.products.slider .product')[slide2].style.height = ""+ finalHeight +"px";
		}
	}

	alertBarHeight();
});


/*************************************************************************************/
// Custom selection land. An ID is REQUIRED to enter

// Mega Multi-select fields
function getValues(id) {
    var result = [];
    var collection = document.querySelectorAll("#" + id + " option");
    collection.forEach(function (x) {
        if (x.selected) {
            result.push(x.value);
        }
    });
    return result;
}

var MegaSelect1 = 'dino-select';
if( $('#'+ MegaSelect1 ).length ){
	var selecDino = new vanillaSelectBox("#"+ MegaSelect1 ,{
		placeHolder: 	"Dino Select",
		"maxWidth": 	"100%",
		"maxHeight": 	400,
		"search": 		false,
	});

	document.querySelector('select#'+ MegaSelect1 ).addEventListener('change', function(){
		document.querySelector('input[name=multi-select-output]').value = getValues( MegaSelect1 );
	});
}

/******************************************/
// Multi-select fields
if( $('#product-interest').length ){
	let productInterest = new vanillaSelectBox( "#product-interest", {
		placeHolder: "Product Interest",
		"maxWidth":"100%",
	} );
}
if( $('#product-interest2').length ){
	let productInterest2 = new vanillaSelectBox( "#product-interest2", {
		placeHolder: "Product Interest",
		"maxWidth":"100%",
	} );
}
if( $('#product-interest3').length ){
	let productInterest3 = new vanillaSelectBox( "#product-interest3", {
		placeHolder: "Product Interest",
		"maxWidth":"100%",
	} );
}

/******************************************/
// Single select fields
if( $('#primary_industry_info').length ){
	let primaryIndustry1 = new vanillaSelectBox( "#primary_industry_info", {
		placeHolder: "Primary Industry *",
		"maxWidth":"100%",
	} );
	primaryIndustry1.options[0].value = "";
}
if( $('#primary_industry2').length ){
	let primaryIndustry2 = new vanillaSelectBox( "#primary_industry2", {
		placeHolder: "Primary Industry *",
		"maxWidth":"100%",
	} );
	primaryIndustry2.options[0].value = "";
}
if( $('#primary_industry').length ){
	let primaryIndustry3 = new vanillaSelectBox( "#primary_industry", {
		placeHolder: "Primary Industry *",
		"maxWidth":"100%",
	} );
	primaryIndustry3.options[0].value = "";
}

/******************************************/
// Mobile Menu
var menu = new Mmenu( "nav.nav-mobile", {
    "extensions": [
        "pagedim-black",
        "position-right"
    ],
    "navbars": [{
        "position": "top",
        "content": [
            '<a href="/"><img src="'+ primary_logo +'" alt="Direct Wire & Cable" /></a>'
        ]
    }, {
        "position": "bottom",
        "content": [
            '<a href="tel:+1'+ main_phone +'">'+ main_phone +'</a>'
        ]
    }, {
        "position": "bottom",
        "content": [
            '<a href="'+ social_facebook +'"  target="_blank" rel="noopener"><span class="icon-facebook"></span></a>',
            '<a href="'+ social_twitter +'"   target="_blank" rel="noopener"><span class="icon-twitter"></span></a>',
            '<a href="'+ social_instagram +'" target="_blank" rel="noopener"><span class="icon-instagram"></span></a>',
            '<a href="'+ social_linkedin +'"  target="_blank" rel="noopener"><span class="icon-linkedin"></span></a>'
        ]
    }, {
        "position": "bottom",
        "content": [
            '<div class="da-flag"><img src="'+ footer_img_src +'" alt="'+ footer_img_alt +'" /></div>'
        ]
    }]
});
var api = menu.API;

api.bind( "open:start", function() {
	$( ".mobile-icon-container .checkbox-wrap" ).addClass( "checked" );
} );
// api.bind('open:finish', function () {
// console.log('open:finish');
// });

api.bind( "close:start", function() {
	$( ".mobile-icon-container .checkbox-wrap" ).removeClass( "checked" );
} );
// api.bind('close:finish', function () {
// console.log('close:finish');
// });



/*************************************************************************************
 * Alert Bar Functions
 *************************************************************************************/
// trigger alert bar on page load if enabled and not already closed
var alertBar_status = alert_status;
var alertBar_cookie = getCookie('alertBar');
if( alertBar_status == true ){
	if(alertBar_cookie != 'closed') {
		document.querySelector('body').classList.add('alert-bar-enabled');
	}

	document.querySelector('.alert-bar-wrapper .alert-close i').addEventListener('click',function () {
		setCookie('alertBar', 'closed', alert_expires);
		alertBarHeight();
	}); 
}

// close alert bar
$( ".alert-bar-wrapper .alert-close i" ).on( "click", function() {
	$( ".alert-bar-wrapper" ).css( { "overflow": "auto" } );
	$( ".alert-bar-wrapper" ).addClass( "animate__animated animate__fadeOut" );
	// setCookie('alertBar', 'closed', 7);  // set in the header via acf
	
	setTimeout( () => {
		$( "body" ).removeClass( "alert-bar-enabled" );
		alertBarHeight();
	}, 400 );
} );

// General height fixing global function for the alert bar
// on page load & on window resize
function alertBarHeight() {

	// Adjust the page for the alert bar height
	// Gets the height of the alert bar
	var height_alert = document.querySelector('.alert-bar-wrapper');
	if( height_alert != null ) {
		height_alert = height_alert.offsetHeight;
		document.querySelector('main').style.marginTop = height_alert + 'px';
	} else {
		height_alert = 0;
	}

	// Adjust the placement of the #nav-placeholder
	// Gets the height of the admin bar if enabled
	var height_admin = document.querySelector('#wpadminbar');
	if( height_admin != null ) {
		height_admin = height_admin.offsetHeight;
	} else {
		height_admin = 0;
	}

	// Jump menu bar placement
	// Required via js due to also accounting for the alert bars actual height since its a WYSIWYG
	var height_jump = document.querySelector('.jump-menu-container');
	var finalJumpHeight = height_alert + height_admin + 60;
	if( height_jump != null ) {
		height_jump.style.top = finalJumpHeight + 'px';
	}
}

// Cookie functions
function setCookie(name, value, days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days*24*60*60*1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}

/*************************************************************************************
 * Call Functions that do need to be called on resize
 *************************************************************************************/
win.resize( function() {
	waitForFinalEvent( function() {
		// parallax
		jQuery(window).trigger('resize').trigger('scroll');

		// jump menu
		if ( window.innerWidth < 1100 ) {
			if(($('.jump-menu-container').find('a').length) == 1){
				//Open the menu and don't bind the toggle.
				$('.jump-menu-container').addClass('open');
			}else if(($('.jump-menu-container').find('a').length) > 1){
				$('.jump-menu-container').click(function(){
					$(this).toggleClass('open');
				});
				$('body').on('click', '.jump-menu-container a', function(){
					$('.jump-menu-container').removeClass('open');
				});
			}
		}
		
		// home page
		if ( window.innerWidth < 1024 ) {
			if ( !$( ".innovation-block-wrapper" ).hasClass( "slick-initialized" ) ) {
				homeInnovation();
			}
		} else {
			if ( $( ".innovation-block-wrapper" ).hasClass( "slick-initialized" ) ) {
				$( ".innovation-block-wrapper" ).slick( "unslick" );
			}
		}
		if ( window.innerWidth < 900 ) {
			if ( !$( ".industry-wrapper" ).hasClass( "slick-initialized" ) ) {
				homeIndustry();
			}
		} else {
			if ( $( ".industry-wrapper" ).hasClass( "slick-initialized" ) ) {
				$( ".industry-wrapper" ).slick( "unslick" );
			}
		}
	}, 500, "resize" );
} ).resize();

/*************************************************************************************
 * Header & Footer Functionality
 *************************************************************************************/
// Sticky Header Functionality
var isLeaving = 0;
var intersectionOptions = {
	root:       null,  // use the viewport
	rootMargin: "0px",
	threshold:  0.6,
};
var headerObserver = new IntersectionObserver( function( e ) {
	
	e.forEach( entry => {
		if ( entry.isIntersecting ) { // Default header when at the top of the page
			primaryHead.classList.remove( "sticky" );
			aboveHead.classList.add( "animate__animated", "animate__fadeIn" );
			aboveHead.classList.remove( "animate__fadeOut" );
			logoFixed.classList.add( "animate__animated", "animate__fadeOut" );
			logoFixed.classList.remove( "animate__fadeIn" );
			logo.classList.add( "animate__animated", "animate__fadeIn" );
			logo.classList.remove( "animate__fadeOut" );
			isLeaving = 1;
			// console.log('class removed');   // error check
			
		} else if ( isLeaving ) { // Header after scrolling
			primaryHead.classList.add( "sticky" );
			aboveHead.classList.add( "animate__animated", "animate__fadeOut" );
			aboveHead.classList.remove( "animate__fadeIn" );
			logoFixed.classList.add( "animate__animated", "animate__fadeIn" );
			logoFixed.classList.remove( "animate__fadeOut" );
			logo.classList.add( "animate__animated", "animate__fadeOut" );
			logo.classList.remove( "animate__fadeIn" );
			$( ".logo.fixed" ).css( { "height": "auto" } );
			$( ".above-main-header" ).removeClass( "search-active" );
			$( "#datafetch" ).hide();
			isLeaving = 0;
			// console.log('class added');     // error check
		}
	} );
}, intersectionOptions );
headerObserver.observe( aboveHeader );


// Search bar on slide out functionality
$( "#menu-above-main-nav .menu__item .icon-search" ).click( function() {
	$( ".above-main-header" ).addClass( "search-active" );
	$( ".above-main-header .search-field" ).focus();
} );
$( ".above-main-header form.search-form .icon-plus.close" ).click( function() {
	$( ".above-main-header" ).removeClass( "search-active" );
	$( "#datafetch" ).hide();
} );

$( ".above-main-header form.search-form input" ).focus( function() {
	if ( $( "#datafetch" ).html().length > 0 ) {
		$( "#datafetch" ).hide();
	}
} );

// Footer social media animation
$( ".social-media li" ).hover( function() {
	$( this ).addClass( "animate__animated animate__pulse animate__infinite" );
}, function() {
	$( this ).removeClass( "animate__animated animate__pulse animate__infinite" );
} );

/*************************************************************************************
 * Other page stuff
 *************************************************************************************/
// Home innovation blocks mobile slide
function homeInnovation() {
	$( ".innovation-block-wrapper" ).slick( {
	    mobileFirst:    true,
	    autoplay:       false,
	    infinite:       true,
	    dots:           false,
	    slidesToShow:   1,
	    slidesToScroll: 1,
	    adaptiveHeight: true,
	    prevArrow:      "<button type=\"button\" class=\"slick-prev icon-previous\"><span class=\"sr-only\">Previous</span></button>",
	    nextArrow:      "<button type=\"button\" class=\"slick-next icon-next\"><span class=\"sr-only\">Next</span></button>",
	} );
}

// Home industry blocks mobile slide
function homeIndustry() {
	$( ".industry-wrapper" ).slick( {
	    mobileFirst:    true,
	    autoplay:       false,
	    infinite:       true,
	    dots:           false,
	    slidesToShow:   1,
	    slidesToScroll: 1,
	    adaptiveHeight: true,
	    prevArrow:      "<button type=\"button\" class=\"slick-prev icon-previous\"><span class=\"sr-only\">Previous</span></button>",
	    nextArrow:      "<button type=\"button\" class=\"slick-next icon-next\"><span class=\"sr-only\">Next</span></button>",
	} );
}


var homeVideo = document.querySelector( '.home-page-product-finder video' );
if( homeVideo != null ){
	var isLeaving2 = 0;
	var videoOptions = {
		root:       null,  // use the viewport
		rootMargin: "0px",
		threshold:  0.6,
	};
	var videoObserver = new IntersectionObserver( function( e ) {
		e.forEach( entry => {
			if ( entry.isIntersecting ) { // Default
				homeVideo.play();
				isLeaving2 = 1;
				// console.log('in view');   // error check
				
			} else if ( isLeaving2 ) { // After scrolling
				homeVideo.pause();
				isLeaving2 = 0;
				// console.log('left view');     // error check
			}
		} );
	}, videoOptions );
	videoObserver.observe( homeVideo );
}


document.addEventListener( "wpcf7mailsent", function( event ) {
	var siteURL = window.location.protocol + "//" + window.location.hostname;
	
	if ( "4595" == event.detail.contactFormId ) {            // Request a Quote
		location = siteURL + "/thank-you-quote/";
	} else if ( "4596" == event.detail.contactFormId ) {     // Request Information
		location = siteURL + "/thank-you-info/";
	} else if ( "4593" == event.detail.contactFormId ) {     // Contact us
		location = siteURL + "/thank-you-contact/";
	} else {                                                // All other forms
	}
}, false );

// Open Request Info Flyout
$( ".request-btn a" ).on( "click", function( e ) {
	e.preventDefault();
	$( ".request-flyout.-info" ).css( { "height": "auto" } );
	$( "body" ).addClass( "request-flyout" );
	$( ".request-flyout.-info" ).addClass( "open" );
} );

// Open request Info flyout Mobile
$( ".request-flyout.-info legend" ).on( "click", function() {
	$( "body" ).addClass( "request-flyout" );
	$( ".request-flyout.-info" ).addClass( "open" );
} );

// Close request Info flyout
$( ".request-flyout .button-close" ).on( "click", function( e ) {
	e.preventDefault();
	$( "body" ).removeClass( "request-flyout" );
	$( ".request-flyout.-info" ).removeClass( "open" );
	$( ".request-flyout.-quote" ).removeClass( "open" );
} );

// Close flyout generic background
$( ".request-flyout-background" ).on( "click", function() {
	$( "body" ).removeClass( "request-flyout" );
	$( ".request-flyout.-info" ).removeClass( "open" );
	$( ".request-flyout.-quote" ).removeClass( "open" );
} );

// Open Request Quote Flyout
$( ".button-dark-blue.open-quote-flyout" ).on( "click", function( e ) {
	e.preventDefault();
	$( ".request-flyout.-quote" ).css( { "height": "auto" } );
	$( "body" ).addClass( "request-flyout" );
	$( ".request-flyout.-quote" ).addClass( "open" );
} );


/*************************************************************************************
 * Smooth Scrolling Thanks to StackOverflow
 * No external library needed!
 *************************************************************************************/
function currentYPosition() {
	// Firefox, Chrome, Opera, Safari
	if ( self.pageYOffset ) return self.pageYOffset;
	// Internet Explorer 6 - standards mode
	if ( document.documentElement && document.documentElement.scrollTop )
		return document.documentElement.scrollTop;
	// Internet Explorer 6, 7 and 8
	if ( document.body.scrollTop ) return document.body.scrollTop;
	return 0;
}

function elmYPosition( eID ) {
	var elm = document.getElementById( eID );
	var y = elm.offsetTop;
	var node = elm;
	while ( node.offsetParent && node.offsetParent != document.body ) {
		node = node.offsetParent;
		y += node.offsetTop;
	}
	return y;
}

function smoothScroll( eID ) {
	var startY = currentYPosition();
	var stopY = elmYPosition( eID );
	var distance = stopY > startY ? stopY - startY : startY - stopY;
	if ( distance < 100 ) {
		scrollTo( 0, stopY );
		return;
	}
	var speed = Math.round( distance / 100 );
	if ( speed >= 20 ) speed = 20;
	var step = Math.round( distance / 25 );
	var leapY = stopY > startY ? startY + step : startY - step;
	var timer = 0;
	if ( stopY > startY ) {
		for ( var i = startY; i < stopY; i += step ) {
			setTimeout( "window.scrollTo(0, " + leapY + ")", timer * speed );
			leapY += step;
			if ( leapY > stopY ) leapY = stopY;
			timer++;
		}
		return;
	}
	for ( var i = startY; i > stopY; i -= step ) {
		setTimeout( "window.scrollTo(0, " + leapY + ")", timer * speed );
		leapY -= step;
		if ( leapY < stopY ) leapY = stopY;
		timer++;
	}
	return false;
}

////////
// The rest of the smooth scrolling 
var linkArray = $( ".jump-menu-placement[data-title]" );
var x = 0;
if ( linkArray.length ) {
	var newElement = $( ".jump-menu-container" );
	newElement.css( { "height": "auto" } );
	newElement.addClass('enabled');
	
	while ( x < linkArray.length ) {
		var elm_title = linkArray[ x ].getAttribute( "data-title" );
		var elm_id = linkArray[ x ].getAttribute( "id" );
		
		// Tried not having it onclick but wasnt able to resolve the errors that followed :(
		newElement.append(
				" <a href=\"#" + elm_id + "\" onclick=\"smoothScroll(&quot;" + elm_id +
				"&quot;);\">" + elm_title + "</a> " );
		x++;
	}
}
